import configureStore from './appRedux/store';

const store = configureStore(/ provide initial state if any /);

export default store;